"use strict";

require("core-js/modules/es6.reflect.delete-property");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.set");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@prodo/core");

var prefix = "prodo:";

var isProdoKey = function isProdoKey(key) {
  return key.startsWith(prefix);
};

var serializeKey = function serializeKey(key) {
  return "" + prefix + key;
};

var deserializeKey = function deserializeKey(key) {
  if (!isProdoKey(key)) {
    throw new Error(key.toString() + " is not handled by prodo.");
  }

  return key.slice(prefix.length);
};

var parseItem = function parseItem(key, item) {
  try {
    return JSON.parse(item);
  } catch (e) {
    throw new Error("Error parsing '" + key.toString() + "' from localStorage\n\n" + item);
  }
};

var getItem = function getItem(config, key) {
  if (config.localFixture != null && config.localFixture.hasOwnProperty(key)) {
    // use fixtures
    return config.localFixture[key];
  }

  var prodoKey = serializeKey(key);
  var localItem = localStorage.getItem(prodoKey);

  if (localItem != null) {
    return parseItem(prodoKey, localItem);
  }

  if (config.initLocal != null && config.initLocal.hasOwnProperty(key)) {
    return config.initLocal[key];
  }

  return undefined;
};

var initFn = function initFn() {
  return function (config, universe) {
    universe.local = {}; // init universe with values from localStorage (or fixtures) and initLocal

    var existingKeys = config.localFixture == null ? Object.keys(localStorage).filter(isProdoKey).map(deserializeKey) : Object.keys(config.localFixture);
    var defaultKeys = Object.keys(config.initLocal || {});
    var keys = Array.from(new Set(__spreadArrays(existingKeys, defaultKeys)));
    universe.local = keys.reduce(function (acc, key) {
      var _a;

      var item = getItem(config, key);

      if (item == null) {
        return acc;
      }

      return __assign(__assign({}, acc), (_a = {}, _a[key] = item, _a));
    }, {}); // use initLocal for any values that have not yet been loaded

    if (config.initLocal != null) {
      Object.keys(config.initLocal).forEach(function (key) {
        if (!universe.local.hasOwnProperty(key)) {
          universe.local[key] = config.initLocal[key];
        }
      });
    }
  };
};

var prepareActionCtx = function prepareActionCtx() {
  return function (_a, config) {
    var ctx = _a.ctx,
        universe = _a.universe;
    ctx.local = new Proxy(universe.local, {
      deleteProperty: function deleteProperty(target, key) {
        var ret = Reflect.deleteProperty(target, key); // place default value back in the universe so it is available
        // in components

        if (config.initLocal && config.initLocal.hasOwnProperty(key)) {
          target[key] = config.initLocal[key];
        }

        return ret;
      }
    });
  };
};

var prepareViewCtx = function prepareViewCtx() {
  return function (_a) {
    var ctx = _a.ctx;
    ctx.local = core_1.createUniverseWatcher("local");
  };
};

var onCompleteEvent = function onCompleteEvent() {
  return function (_a, config) {
    var event = _a.event;

    if (config.localFixture != null) {
      // do not update localStorage if using fixtures
      return;
    }

    var prevLocal = event.prevUniverse.local;
    var nextLocal = event.nextUniverse.local; // save everything on nextUniverse.local to localStorage

    Object.keys(nextLocal).forEach(function (pathKey) {
      localStorage.setItem(serializeKey(pathKey), JSON.stringify(nextLocal[pathKey]));
    }); // remove items that were deleted

    Object.keys(prevLocal).forEach(function (pathKey) {
      var keyDeleted = !nextLocal.hasOwnProperty(pathKey);

      if (keyDeleted) {
        localStorage.removeItem(serializeKey(pathKey));
      }
    });
  };
};

var localPlugin = function localPlugin() {
  var plugin = core_1.createPlugin("local");
  plugin.init(initFn());
  plugin.prepareActionCtx(prepareActionCtx());
  plugin.prepareViewCtx(prepareViewCtx());
  plugin.exposeUniverseVars(["local"]);
  plugin.onCompleteEvent(onCompleteEvent());
  return plugin;
};

exports["default"] = localPlugin;